<met-page-layout>
  <div class="operator-view">
    <div class="title">
      <h3 routerLink="/operators" style="cursor: pointer; text-decoration: underline">Betreiberübersicht</h3>
      <mat-icon class="mat-icon-header">keyboard_arrow_right</mat-icon>
      <h3 *ngIf="operator.lastName; else vhOperatorIds">{{ operator.lastName }}</h3>
      <ng-template #vhOperatorIds>
        <h3>{{ operator.vhOperatorId }}</h3>
      </ng-template>
    </div>
    <div class="edit-Operator-view">
      <div>
        <div>
          <met-edit-operator-field
            fieldName="Id"
            [operatorValue]="operator.vhOperatorId"
            (valueChange)="changeValue('id', $event)">

            <ng-template #control let-value="value" let-setValue="setValue">
              <input
                class="met-input"
                [formControl]="searchId"
                [matAutocomplete]="autoId"
                (input)="onNameInput('id', $event); setValue($any($event.target).value)"
              />
              <mat-autocomplete
                #autoId="matAutocomplete"
                autoActiveFirstOption
                [displayWith]="displayOperator"
                (optionSelected)="onOperatorPicked($event.option.value)">
                <mat-option *ngFor="let op of (filteredOperators$ | async)" [value]="op">
                  {{ op.lastName }}, {{ op.firstName }} · {{ op.vhOperatorId }}
                </mat-option>
                <mat-option *ngIf="(showNoResults$ | async)" disabled>Keine Treffer</mat-option>
              </mat-autocomplete>
            </ng-template>
          </met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field
            fieldName="Vorname"
            [operatorValue]="operator.firstName"
            (valueChange)="changeValue('firstName', $event)">

            <ng-template #control let-value="value" let-setValue="setValue">
              <input
                class="met-input"
                [formControl]="searchFirstName"
                [matAutocomplete]="autoFirst"
                (input)="onNameInput('firstName', $event); setValue($any($event.target).value)"/>
              <mat-autocomplete
                #autoFirst="matAutocomplete"
                autoActiveFirstOption
                [displayWith]="displayOperator"
                (optionSelected)="onOperatorPicked($event.option.value)">
                <mat-option *ngFor="let op of (filteredOperators$ | async)" [value]="op">
                  {{ op.lastName }}, {{ op.firstName }} · {{ op.vhOperatorId }}
                </mat-option>
                <mat-option *ngIf="(showNoResults$ | async)" disabled>Keine Treffer</mat-option>
              </mat-autocomplete>
            </ng-template>
          </met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field
            fieldName="Nachname"
            [operatorValue]="operator.lastName"
            (valueChange)="changeValue('lastName', $event)">

            <ng-template #control let-value="value" let-setValue="setValue">
              <input
                class="met-input"
                [formControl]="searchLastName"
                [matAutocomplete]="autoLast"
                (input)="onNameInput('lastName', $event); setValue($any($event.target).value)"
                />
              <mat-autocomplete
                #autoLast="matAutocomplete"
                autoActiveFirstOption
                [displayWith]="displayOperator"
                (optionSelected)="onOperatorPicked($event.option.value)">
                <mat-option *ngFor="let op of (filteredOperators$ | async)" [value]="op">
                  {{ op.lastName }}, {{ op.firstName }} · {{ op.vhOperatorId }}
                </mat-option>
                <mat-option *ngIf="(showNoResults$ | async)" disabled>Keine Treffer</mat-option>
              </mat-autocomplete>
            </ng-template>
          </met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field fieldName="Straße" [operatorValue]="operator.street"
                                   (valueChange)="changeValue('street', $event)"></met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field fieldName="PLZ" [operatorValue]="operator.postCode"
                                   (valueChange)="changeValue('postCode', $event)"></met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field fieldName="Ort" [operatorValue]="operator.city"
                                   (valueChange)="changeValue('city', $event)"></met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field fieldName="Telefon" [operatorValue]="operator.phoneNumber"
                                   (valueChange)="changeValue('phoneNumber', $event)"></met-edit-operator-field>
        </div>
        <div>
          <met-edit-operator-field fieldName="E-Mail" [operatorValue]="operator.email"
                                   (valueChange)="changeValue('email', $event)"></met-edit-operator-field>
        </div>
        <div class="headline">
          Stationen des Betreibers
        </div>
        <div class="stations" *ngFor="let station of operator.stationMap | keyvalue">
          <div>
            <met-operator-station-view [stationId]="station.key" [stationName]="station.value"
                                       (delete)="deleteStation(station.key)"
            ></met-operator-station-view>
          </div>
        </div>
        <div class="add-icon">
          <mat-icon style="transform: scale(1.5); cursor: pointer" (click)="openAddStation()">add</mat-icon>
        </div>
        <div *ngIf="status" class="status-message">
          Änderungen wurden gespeichert!
        </div>
        <div class="buttons">
          <div>
            <met-button buttonText="Abbrechen" routerLink="/operators"></met-button>
          </div>
          <div>
            <met-button *ngIf="deletable" buttonText="Löschen"
                        (click)="openDialog()"></met-button>
          </div>
          <div>
            <met-button buttonText="Speichern" (click)="save()"></met-button>
          </div>
        </div>
      </div>
    </div>

  </div>

</met-page-layout>
